// extracted by mini-css-extract-plugin
export default {"wrapper":"iVoi4","infoBlocks":"pGiS_","block":"lb53G","icon":"dNOda","title":"yVbt7","description":"NGPDO"};